import { useState, useContext, useEffect } from "react";
import UserContext from "./UserContext";  // ✅ Add this

const UploadSong = () => {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  const [uploading, setUploading] = useState(false);  // ✅ Add loading state
  const { user } = useContext(UserContext);  // ✅ Get user from context
  const [genres, setGenres] = useState([]);
  const [selectedGenreIds, setSelectedGenreIds] = useState([]);
  const [songPicture, setSongPicture] = useState(null);

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  useEffect(() => {
  fetch("/api/genres/")
    .then(res => res.json())
    .then(data => setGenres(data))
    .catch(() => setMessage("Could not load genres."));
}, []);

  const handleUpload = async () => {
    if (!file) {
      setMessage("Please select a file.");
      return;
    }

    if (selectedGenreIds.length < 1) {
        setMessage("Please choose 1 or 2 genres.");
        return;
}

    const formData = new FormData();
    formData.append("file", file);
    if (songPicture) {
        formData.append("song_picture", songPicture);
    }

    selectedGenreIds.forEach(id => {
      formData.append("genre_ids", id);
    });

    setUploading(true);  // ✅ Show loading
    setMessage("Uploading and converting...");

    try {
      const response = await fetch("/api/upload_song/", {  // ✅ Relative URL
        method: "POST",
        headers: {
          Authorization: `Bearer ${user.token}`,  // ✅ Fixed - use user.token
        },
        body: formData,
      });

      const data = await response.json();

      if (response.ok) {
        setMessage("Upload successful! Refresh to see your new song.");
        setFile(null);  // Clear file input
	setSongPicture(null);
        setSelectedGenreIds([]);
      } else {
        setMessage(data.error || "Upload failed.");
      }
    } catch (error) {
      setMessage("Something went wrong.");
    } finally {
      setUploading(false);  // ✅ Hide loading
    }
  };

  const toggleGenre = (genreId) => {
  setSelectedGenreIds(prev => {
    if (prev.includes(genreId)) {
      return prev.filter(id => id !== genreId);
    }

    if (prev.length >= 2) {
      setMessage("Pick 1 or 2 genres max.");
      return prev;
    }

    return [...prev, genreId];
  });
};


  return (
    <div style={{ 
      background: "rgba(255, 215, 0, 0.1)", 
      padding: "15px", 
      marginTop: "20px",
      borderRadius: "5px"
    }}>
      <h3>Upload a Song</h3>
      <input 
  type="file" 
  accept="audio/*"
  onChange={handleFileChange} 
  disabled={uploading}
/>
	  <div style={{ marginTop: "10px" }}>
  <div
    style={{
      color: "#000",
      fontWeight: "900",
      marginBottom: "5px"
    }}
  >
    Song Artwork (optional)
  </div>

  <input
    type="file"
    accept="image/*"
    onChange={(e) => setSongPicture(e.target.files[0])}
    disabled={uploading}
  />
</div>

<div style={{ marginTop: "12px", marginBottom: "12px" }}>
  <div style={{ fontWeight: "900", marginBottom: "8px", color: "#000" }}>
    Genre: pick 1 or 2
  </div>

  <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
    {genres.map(genre => {
	    const selected = selectedGenreIds.includes(genre.id);
            const maxReached = selectedGenreIds.length >= 2 && !selected;

      return (
        <button
          key={genre.id}
          type="button"
          onClick={() => toggleGenre(genre.id)}
          disabled={uploading || maxReached}
          style={{
            padding: "6px 9px",
            borderRadius: "999px",
            border: selected ? "2px solid #000" : "1px solid #999",
            background: selected ? "#FFD700" : "#f0f0f0",
            color: "#000",
	    opacity: maxReached ? 0.45 : 1,	  
            fontWeight: "900",
	    cursor: uploading || maxReached ? "not-allowed" : "pointer",

          }}
        >
          {genre.name}
        </button>
      );
    })}
  </div>
</div>

<button 
  onClick={handleUpload}
        disabled={uploading}
        style={{
          marginLeft: "10px",
          padding: "5px 10px",
          background: uploading ? "#ccc" : "#FFD700",
          border: "none",
          borderRadius: "3px",
          cursor: uploading ? "not-allowed" : "pointer"
        }}
      >
        {uploading ? "Processing..." : "Upload"}
      </button>
      {message && <p style={{ marginTop: "10px", color: "#FFD700" }}>{message}</p>}
    </div>
  );
};

export default UploadSong;
